<template>
  <path
    d="M19 2.00018H5C3.9 2.00018 3 2.90018 3 4.00018V18.0002C3 19.1002 3.9 20.0002 5 20.0002H9L11.29 22.2902C11.68 22.6802 12.31 22.6802 12.7 22.2902L15 20.0002H19C20.1 20.0002 21 19.1002 21 18.0002V4.00018C21 2.90018 20.1 2.00018 19 2.00018ZM13.88 12.8802L12 17.0002L10.12 12.8802L6 11.0002L10.12 9.12018L12 5.00018L13.88 9.12018L18 11.0002L13.88 12.8802Z"
  />
</template>
